function _typeof(o) {
    '@babel/helpers - typeof';
    return module.exports = _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, module.exports.__esModule = true, module.exports['default'] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports['default'] = module.exports;